//#region src/engine/modules/dictionary/membership.ts
var listings = /* @__PURE__ */ new WeakMap();
function listingOf(list) {
	const held = listings.get(list);
	if (held && held.length === list.length) return held;
	const listing = {
		ids: new Set(list),
		length: list.length
	};
	listings.set(list, listing);
	return listing;
}
var isListed = (list, id) => listingOf(list).ids.has(id);
function listId(list, id) {
	const listing = listingOf(list);
	if (listing.ids.has(id)) return false;
	list.push(id);
	listing.ids.add(id);
	listing.length = list.length;
	return true;
}
function unlistId(list, id) {
	const listing = listingOf(list);
	if (!listing.ids.has(id)) return false;
	const index = list.lastIndexOf(id);
	if (index !== -1) list.splice(index, 1);
	listing.ids.delete(id);
	listing.length = list.length;
	return true;
}
var toLiveDomainId = (state, domainId) => domainId && isListed(state.doc.domainIds, domainId) ? domainId : "";
function toPastedDomainId(state, domainId, dataType) {
	const id = toLiveDomainId(state, domainId);
	const domainType = state.collections.domainEntities[id]?.dataType ?? "";
	return id && domainType === dataType ? id : "";
}
function getLiveDomainName(state, domainId) {
	if (!domainId || !isListed(state.doc.domainIds, domainId)) return "";
	return state.collections.domainEntities[domainId]?.name ?? "";
}
//#endregion
export { getLiveDomainName, isListed, listId, toLiveDomainId, toPastedDomainId, unlistId };
